import { Steps } from 'antd';
import { css, styled } from 'styled-components';
import { IStepsProps } from './types';

const variants = {
  default: css``,
  custom: css``,
};

export const StyledSteps = styled(Steps)<Pick<IStepsProps, 'hasHover' | 'variant'>>`
  border-radius: 16px !important;
  padding: 16px !important;
  border: 1px solid ${props => props.theme.colors.neutral.light.divider} !important;
  background-color: ${props => props.theme.colors.secondary.light.contentBg} !important;

  ${({ variant }) => variants[variant || 'default']}

  .ant-steps-item-title {
    font-size: 16px !important;
    color: ${props => props.theme.colors.primary.main.filled} !important;
  }

  .ant-steps-item-description {
    font-size: 0.875rem !important;
    color: ${props => props.theme.colors.secondary.main.text} !important;
  }

  .ant-steps-item-icon {
    border: none !important;
    width: 16px !important;
    height: 16px !important;
    border-radius: 4px !important;
    font-size: unset !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    margin-right: 8px !important;
  }

  .ant-steps-item-container {
    display: flex;
    align-items: center !important;
  }

  .ant-steps-item-container:hover {
    background-color: ${props =>
      props.hasHover ? props.theme.colors.primary.light.filled : ''} !important;
    border-radius: 8px !important;
  }

  .ant-steps-item-icon > .ant-steps-icon {
    font-size: 12px !important;
  }

  .ant-steps-item-active .ant-steps-item-icon {
    background: ${props => props.theme.colors.primary.main.filled} !important;
  }

  .ant-steps-item-active .ant-steps-item-title {
    color: ${props => props.theme.colors.primary.main.filled} !important;
  }

  .ant-steps-item-active .ant-steps-item-icon > .ant-steps-icon {
    color: ${props => props.theme.colors.secondary.light.contentBg} !important;
  }

  .ant-steps-item-finish .ant-steps-item-icon {
    background: ${props => props.theme.colors.neutral.main.filled} !important;
  }

  .ant-steps-item-finish .ant-steps-item-title {
    color: ${props => props.theme.colors.neutral.main.filled} !important;
  }

  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: ${props => props.theme.colors.secondary.light.contentBg} !important;
  }

  .ant-steps-item-wait .ant-steps-item-icon {
    background: transparent !important;
    border: 1px solid ${props => props.theme.colors.neutral.light.divider} !important;
  }

  .ant-steps-item-wait .ant-steps-item-title {
    color: ${props => props.theme.colors.secondary.main.text} !important;
  }

  .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon {
    color: ${props => props.theme.colors.neutral.main.text} !important;
  }

  .ant-steps-item-title::after {
    border: dashed 0.5px ${props => props.theme.colors.neutral.light.divider} !important;
    background: transparent !important;
  }

  .ant-steps-item-finish .ant-steps-item-title::after {
    border: dashed 0.5px ${props => props.theme.colors.neutral.main.filled} !important;
    background: transparent !important;
  }

  .ant-steps-item-active .ant-steps-item-title::after {
    border: dashed 0.5px ${props => props.theme.colors.primary.main.filled} !important;
    background: transparent !important;
  }
`;
